import { Monitor, Mouse, Columns3, Sparkles } from "lucide-react";

const reasons = [
  {
    icon: Columns3,
    title: "Three-pane reading",
    body: "Text in the middle, vocab panels left and right. It physically does not fit on a phone.",
  },
  {
    icon: Mouse,
    title: "Mouse-first",
    body: "Mark known, ignore, advance — all without leaving the home row. Touch would slow you down.",
  },
  {
    icon: Sparkles,
    title: "Long-form attention",
    body: "Real reading happens at a desk, with coffee, for thirty minutes. Verbatim is built for that, not for waiting on the bus.",
  },
];

export const DesktopOnly = () => {
  return (
    <section
      id="desktop"
      data-testid="desktop-only-section"
      className="relative py-20 sm:py-24"
    >
      <div className="container-x">
        <div className="card-soft relative overflow-hidden p-8 sm:p-12 lg:p-16 reveal">
          <div className="absolute inset-0 dot-grid opacity-40" aria-hidden />
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-[var(--vb-primary)]/8 blur-3xl" aria-hidden />

          <div className="relative grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-6">
              <div className="pill pill-blue mb-5">
                <Monitor size={12} /> Desktop only
              </div>
              <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.02]">
                There's no phone app.
                <br />
                <span className="text-[var(--vb-muted)] italic font-light">
                  On purpose.
                </span>
              </h2>
              <p className="mt-5 text-[var(--vb-muted)] text-base max-w-lg">
                Verbatim is for sitting down with a chapter, not for swiping
                between subway stops. The whole interface assumes a wide
                screen, a real mouse, and thirty quiet minutes.
              </p>
              <p className="mt-3 text-sm text-[var(--vb-muted)]/80">
                If you're on mobile right now — bookmark this and open it from
                your laptop tonight.
              </p>
            </div>

            <div className="lg:col-span-6 grid sm:grid-cols-3 gap-3">
              {reasons.map((r, i) => (
                <div
                  key={i}
                  data-testid={`desktop-reason-${i}`}
                  className="bg-[var(--vb-bg)]/60 border border-[var(--vb-border)] rounded-xl p-5"
                >
                  <r.icon size={18} className="text-[var(--vb-primary)] mb-4" />
                  <div className="font-display font-bold text-sm mb-1.5">
                    {r.title}
                  </div>
                  <div className="text-xs text-[var(--vb-muted)] leading-relaxed">
                    {r.body}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
